<form (ngSubmit)="onAddArticle(articleForm)" #articleForm="ngForm">
  <div class="grid-x">
    <div class="large-6 small-12">
      <label for="title">Title</label>
      <input type="text" id="title" name="title" required [(ngModel)]="formData.title" >
    </div>
    <div class="large-6 small-12">
      <label for="bg">Select background</label>
      <select name="bg" id="bg" [(ngModel)]="formData.bg">
        <option value="home">Black Piano</option>
        <option value="bg2">Light Piano</option>
        <option value="dark">Dark</option>
        <option value="piano-goldwork">Piano Goldwork</option>
        <option value="string-casing">String Casings</option>
        <option value="restringing">Restringing</option>
        <option value="keybed">Keybeds</option>
        <option value="action">Action on wall</option>
        <option value="steinway-polished">Steinway Polished</option>
        <option value="kate-working">Kate Working</option>
        <option value="kate-mopping">Kate Mopping</option>
        <option value="aiden-working">Aiden Working</option>
        <option value="aiden-tuning">Aiden Tuning</option>
        <option value="adjustments">Adjustments</option>
      </select>
    </div>
    <div class="large-2 small-4">
      <label for="order">Place in list</label>
      <input type="text" id="order" name="order" required [(ngModel)]="formData.order" >
    </div>
  </div>

  <label for="content">Area Content</label>
  <textarea [(ngModel)]="formData.content" name="content" id="content" cols="30" rows="10"></textarea>
  <label for="imageIsFile">Image from link</label>
  <input type="checkbox" id="imageIsFile" name="imageIsFile" [(ngModel)]="formData.imageIsFile"> &nbsp;
    <small style="color: black">You can paste the url of an image in here, and it will be the image displayed, if you disable image from link you can then upload a file to the image editor and select from the gallery below, the current selected image is highlighed in red.</small>

  @if (!formData.imageIsFile) {
    <div class="image-upload">
      <input type="file" id="fileElem"
        accept="image/*"
        (change)="addImage($event)">
      @if (formData.image) {
        <img [src]="formData.image" alt="">
      }
    </div>
  }

  @if (formData.imageIsFile) {
    <div class="file-link">
      <label for="fileLink">File link</label>
      <input type="text" id="fileLink" name="fileLink" [(ngModel)]="formData.fileLink" >
    </div>
  }
  <div class="large-6 small-12">
    <label for="picture_text">Picture Text</label>
    <input type="text" id="picture_text" name="picture_text" [(ngModel)]="formData.picture_text" >
  </div>
  <app-image-picker class="image-picker-scroll"
    [images]="images"
    [selectedPaths]="image ? [image] : []"
    (select)="selectImage($event.path)"
    (deleted)="onImageDeleted($event)">
  </app-image-picker>
  <button class="button" type="submit" [disabled]="!articleForm.valid">Save</button>
</form>
